import { render } from "./Input-Textarea.vue?vue&type=template&id=183d72e1"
import script from "./Input-Textarea.vue?vue&type=script&lang=js"
export * from "./Input-Textarea.vue?vue&type=script&lang=js"

import "./Input-Textarea.vue?vue&type=style&index=0&id=183d72e1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__